import Link from '@/components/AppLink';
import { Share03Icon } from "@vetty/icons";
import styles from "./OverviewSection.module.scss";

type OverviewSectionProps = {
  title: string;
  href?: string;
  children: React.ReactNode;
};

export const OverviewSection = ({ title, href, children }: OverviewSectionProps) => {
  return (
    <section className={styles["comp"]}>
      <div className={styles["comp__head"]}>
        <h2 className={styles["comp__title"]}>{title}</h2>
        {href ? (
          <Link
            className={styles["comp__iconLink"]}
            href={href}
            aria-label={`Open ${title}`}
          >
            <Share03Icon style={{ width: 16, height: 16 }} />
          </Link>
        ) : null}
      </div>
      <div className={styles["comp__body"]}>{children}</div>
    </section>
  );
};
